import React, { useCallback } from "react";

import styles from "./Bubble.module.scss";
import {
  Body5,
  LeftBubble,
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@bale/ui";
import { useTheme } from "@emotion/react";
import classNames from "classnames";
import { strings } from "intl/fa";

interface BubbleProps {
  imageSrc?: string;
  caption: string;
  containerRef?: React.RefObject<HTMLImageElement>;
  button_title?: string;
  button_link?: string;
}

function buildUrl(link: string) {
  return link.startsWith("http") ? link : `https://${link}`;
}

const BubbleFC: React.FC<React.PropsWithChildren<BubbleProps>> = ({
  caption,
  imageSrc,
  button_title,
  button_link,
  containerRef,
}) => {
  const theme = useTheme();
  const { photoWidth, photoHeight } = { photoHeight: 100, photoWidth: "100%" };
  const Image = useCallback(
    () => (
      <img
        src={imageSrc}
        ref={containerRef}
        className={styles.original}
        style={{
          width: photoWidth,
          height: photoHeight,
        }}
        alt="ad preview"
      />
    ),
    [imageSrc]
  );

  function handleClick() {
    if (!button_link) return;
    window.open(buildUrl(button_link), "_blank");
  }

  return (
    <div
      style={{ margin: 16, padding: 8, minWidth: 300 }}
      className={classNames(styles.bubble, styles.narrow)}
    >
      {imageSrc && (
        <div
          className={styles.photo}
          style={{
            width: photoWidth,
            height: photoHeight,
          }}
        >
          <div
            className={styles.wrapper}
            style={{
              width: photoWidth,
              height: photoHeight,
            }}
          >
            <Image />
          </div>
        </div>
      )}
      <div className={styles.caption}>{caption}</div>
      {button_link && (
        <NewButton
          className={styles.button}
          onClick={handleClick}
          size={NewButtonSize.SMALL}
          variant={NewButtonVariant.OUTLINED}
        >
          {button_title || strings.sponsored_messages.view_details}
        </NewButton>
      )}
      <Body5 className={styles.ad}> تبلیغ</Body5>
      <LeftBubble
        color={theme.colors.light[20]}
        size={1}
        className={styles.tail}
      />
    </div>
  );
};

export const Bubble = React.memo(BubbleFC);
